import Vue from 'vue'
import App from './App.vue'
import router from './routes/index'
import store from './store'
import { auth } from './helpers/firebase'
// eslint-disable-next-line
import styles from './assets/styles/app.scss'

// ---
// Carbon Design System Components
import "carbon-components/css/carbon-components.css";
import CarbonComponentsVue from "@carbon/vue/src/index";
Vue.use(CarbonComponentsVue);
// ---
// Modals
import VModal from 'vue-js-modal'
Vue.use(VModal)
// ---
// Vue Headful
import VueMeta from 'vue-meta'
Vue.use(VueMeta)
// ---
// Vue Confetti - let's celebrate!
import VueConfetti from 'vue-confetti'
Vue.use(VueConfetti)
// ---
// Vue Tooltip
import VTooltip from 'v-tooltip'
Vue.use(VTooltip)

Vue.config.productionTip = false

auth.onAuthStateChanged(() => {
  new Vue({
    router,
    store,
    render: h => h(App),
    mounted: function () {
      document.addEventListener('click', this.onClick)
    },
    beforeDestroy: function () {
      document.removeEventListener('click', this.onClick)
    }
  }).$mount('#app')
})
